import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserType } from '@ps/core-models';

import {
  ProjectManager,
  Survey,
  SurveyTransactionStatus,
  TemplateFolder,
} from '@ps/survey-utils';

export const SurveyReferenceActions = createActionGroup({
  source: 'Survey Reference',
  events: {
    'Load Templates': props<{
      hasImpersonatedBuyer: boolean;
      companyId: number;
    }>(),
    'Load Buyer Managers': props<{ companyId: number }>(),
    'Load Operator Managers': emptyProps(),
    'Load Transaction Statuses': emptyProps(),
    'Download Combined ST Report': props<{
      cmp: number;
      userType: UserType;
      surveys: Survey[];
      statuses: number[];
      includeTestTransactions: boolean;
    }>(),
  },
});

export const SurveyReferenceApiActions = createActionGroup({
  source: 'Survey Reference API',
  events: {
    'Load Templates Success': props<{
      templates: TemplateFolder[];
      cachedAt: number;
      companyId: number;
    }>(),
    'Load Templates Failure': props<{ error: string }>(),
    'Load Buyer Managers Success': props<{
      managers: ProjectManager[];
      cachedAt: number;
      companyId: number;
    }>(),
    'Load Buyer Managers Failure': props<{ error: string }>(),
    'Load Operator Managers Success': props<{
      managers: ProjectManager[];
      cachedAt: number;
    }>(),
    'Load Operator Managers Failure': props<{ error: string }>(),
    'Load Transaction Statuses Success': props<{
      statuses: SurveyTransactionStatus[];
      cachedAt: number;
    }>(),
    'Load Transaction Statuses Failure': props<{ error: string }>(),
    'Download Combined ST Report Success': emptyProps(),
    'Download Combined ST Report Failure': props<{ error: string }>(),
  },
});
